import React, { useEffect, useReducer, useState } from 'react';
import { constants, Globals } from '../misc/helpers';
import RotateCamera from './uiElements/unityIntegration/RotateCamera';
import LookAtObject from './uiElements/unityIntegration/LookAtObject';
import LookAtObjectTutorial from './uiElements/unityIntegration/LookAtObjectTutorial';
import Assessment from './uiElements/regular/Assessment';
import BinaryQuestion from './uiElements/regular/BinaryQuestion';
import BleedingControlKit from './uiElements/regular/BleedingControlKit';
import BleedoutTimer from './uiElements/regular/BleedoutTimer';
import Feedback from './uiElements/regular/Feedback';
import ApplyPPE from './uiElements/unityIntegration/ApplyPPE';
import ApplyPressure from './uiElements/unityIntegration/ApplyPressure';
import Call911 from './uiElements/unityIntegration/Call911';
import TourniquetePlacement from './uiElements/unityIntegration/TourniquetePlacement';
import TourniqueteRotation from './uiElements/unityIntegration/TourniqueteRotation';
import PauseMenu from './uiElements/regular/PauseMenu';
import PauseMenuTutorial from './uiElements/regular/PauseMenuTutorial';
import GenericModal from './uiElements/regular/GenericModal';
import Start from './uiElements/regular/Start';
import ScenarioStart from './uiElements/regular/ScenarioStart';
import { ReactUI } from '../core/ReactUI';
import './InGameUI.css';
import Aar from './uiElements/regular/Aar';
import EmsContainer from './uiElements/regular/EmsContainer';
import BackToMainMenu from './uiElements/regular/BackToMainMenu';
import DebugMenu from './uiElements/regular/DebugMenu';
import Tools from '../core/Misc/Tools';

const ui = new ReactUI();

const reducer = (state: any, action: any) => {
	var result = ui.reducer(state, action);
	return result;
};
const InGameUI = (props: any) => {
	const [uisRegistered, setUisRegistered] = useState(false);
	const [forceUpdate, setForceUpdate] = useState(false);
	const [enableDebugMenu, setEnableDebugMenu] = useState(false);
	const [state, dispatch] = useReducer(reducer, {
		uiProps: null,
		gameManager: props.gameManager
	});

	var debugTimeout: any = undefined;

	var startDebugTimeout = () => {
		if(debugTimeout) {
			clearTimeout(debugTimeout);
			debugTimeout = undefined;
		}

		debugTimeout = setTimeout(() => {
			if(window && (window as any)['gameDebug'] !== enableDebugMenu) {
				setEnableDebugMenu((window as any)['gameDebug']);
			}
			startDebugTimeout();
		}, 3000);
	};


	useEffect(() => {
		ui.validateUIPrps(state, dispatch);
		$(window).resize();

		if(Globals.markCurrentScenarioAsCompleted) {
			props.forceUpdate();
		}



		if(uisRegistered) {
			return;
		}

		startDebugTimeout();
		setUisRegistered(true);
		ui.init(dispatch, constants.InGameUINames);

		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.Assessment);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.BinaryQuestion);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.BleedingControlKit);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.BleedoutTimer);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.Feedback);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.ApplyPPE);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.ApplyPressure);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.Call911);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.RotateCamera);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.LookAtObject);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.LookAtObjectTutorial);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.TourniquetePlacement);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.TourniqueteRotation);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.PauseMenu);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.PauseMenuTutorial);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.Aar);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.Start);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.ScenarioStart);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.BackToMainMenu);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.EmsContainer);
		ui.registerUI(state.gameManager.UiManager, dispatch, constants.InGameUINames.GenericModal);
	}, [state, Globals.markCurrentScenarioAsCompleted]);
	return state.uiProps && state.gameManager && state.gameManager.environment && state.gameManager.environment.isReady ? (
		<div className="in-game-ui-container ui-container-root">
			{ui.renderUiComponent(state, constants.InGameUINames.Assessment, <Assessment updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.Assessment].parameters}></Assessment>)}
			{ui.renderUiComponent(state, constants.InGameUINames.BinaryQuestion, <BinaryQuestion updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.BinaryQuestion].parameters}></BinaryQuestion>)}
			{ui.renderUiComponent(state, constants.InGameUINames.BleedingControlKit, <BleedingControlKit updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.BleedingControlKit].parameters}></BleedingControlKit>)}
			{/* {ui.renderUiComponent(state, constants.InGameUINames.BleedoutTimer, <BleedoutTimer dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.BleedoutTimer].parameters}></BleedoutTimer>)} */}
			{ui.renderUiComponent(state, constants.InGameUINames.Feedback, <Feedback updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.Feedback].parameters}></Feedback>)}
			{ui.renderUiComponent(state, constants.InGameUINames.ApplyPPE, <ApplyPPE updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.ApplyPPE].parameters}></ApplyPPE>)}
			{ui.renderUiComponent(state, constants.InGameUINames.ApplyPressure, <ApplyPressure updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.ApplyPressure].parameters}></ApplyPressure>)}
			{ui.renderUiComponent(state, constants.InGameUINames.Call911, <Call911 updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.Call911].parameters}></Call911>)}
			{ui.renderUiComponent(state, constants.InGameUINames.RotateCamera, <RotateCamera updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.RotateCamera].parameters}></RotateCamera>)}
			{ui.renderUiComponent(state, constants.InGameUINames.LookAtObject, <LookAtObject updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.LookAtObject].parameters}></LookAtObject>)}
			{ui.renderUiComponent(state, constants.InGameUINames.LookAtObjectTutorial, <LookAtObjectTutorial updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.LookAtObjectTutorial].parameters}></LookAtObjectTutorial>)}
			{ui.renderUiComponent(state, constants.InGameUINames.TourniquetePlacement, <TourniquetePlacement updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.TourniquetePlacement].parameters}></TourniquetePlacement>)}
			{ui.renderUiComponent(state, constants.InGameUINames.TourniqueteRotation, <TourniqueteRotation updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.TourniqueteRotation].parameters}></TourniqueteRotation>)}
			{ui.renderUiComponent(state, constants.InGameUINames.PauseMenu, <PauseMenu updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.PauseMenu].parameters} timerParams={state.uiProps[constants.InGameUINames.BleedoutTimer].parameters}></PauseMenu>)}
			{ui.renderUiComponent(state, constants.InGameUINames.PauseMenuTutorial, <PauseMenuTutorial updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.PauseMenuTutorial].parameters}></PauseMenuTutorial>)}
			{ui.renderUiComponent(state, constants.InGameUINames.GenericModal, <GenericModal updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.GenericModal].parameters}></GenericModal>)}
			{ui.renderUiComponent(state, constants.InGameUINames.Aar, <Aar updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.Aar].parameters}></Aar>)}
			{ui.renderUiComponent(state, constants.InGameUINames.Start, <Start updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.Start].parameters}></Start>)}
			{ui.renderUiComponent(state, constants.InGameUINames.ScenarioStart, <ScenarioStart updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.ScenarioStart].parameters}></ScenarioStart>)}
			{ui.renderUiComponent(state, constants.InGameUINames.BackToMainMenu, <BackToMainMenu updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.BackToMainMenu].parameters}></BackToMainMenu>)}
			{ui.renderUiComponent(state, constants.InGameUINames.EmsContainer, <EmsContainer updateWindow={props.updateWindow} dispatch={dispatch} parameters={state.uiProps[constants.InGameUINames.EmsContainer].parameters}></EmsContainer>)}
			{state.gameManager.SoundManager.render()}
			{
				enableDebugMenu ? (<DebugMenu forceUpdate={() => {
					setForceUpdate(!forceUpdate);
				}}></DebugMenu>) : null
			}
			
		</div>
	) : (null);
};

export default InGameUI;
